import { Platform } from '@/types/PlatformType';
import { AxiosRequestConfig } from 'axios';
import http from './api-client';

const apiEndpoint = '/platforms/lists/parents';

/**
 * Fetches the list of platforms from the API.
 * @param signal - AbortSignal for canceling the request
 * @returns Promise containing the platforms list
 */
export const getPlatforms = async (config?: AxiosRequestConfig): Promise<Platform[]> =>
    await http
        .get<Platform[]>(apiEndpoint, { ...config })
        .then((res) => res.data);
